export default __webpack_public_path__ + "static/media/14.c7475451.jpeg";